import CityPageTemplate from "../city-template/CityPageTemplate";
import { battleCreekConfig } from "./data";

export default function BattleCreekPage() {
  return <CityPageTemplate config={battleCreekConfig} />;
}